<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="审核状态" prop="status">
                <a-select v-model="queryParam.status" allow-clear placeholder="请选择审核状态">
                  <a-select-option value="0">待审核</a-select-option>
                  <a-select-option value="1">已通过</a-select-option>
                  <a-select-option value="2">已驳回</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="提现时间" prop="withdrawalTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.withdrawalTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="审核时间" prop="examineTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.examineTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="withdrawalTime" slot-scope="text, record">
          {{ parseTime(record.withdrawalTime) }}
        </span>
        <span slot="examineTime" slot-scope="text, record">
          {{ parseTime(record.examineTime) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a
            :disabled="record.status !== 0"
            v-hasPermi="['master:withdrawal:edit']"
            @click="$refs.createForm.handleUpdate(record, undefined)"
          >
            <a-icon type="edit"/>审核
          </a>
        </span>
        <span slot="status" slot-scope="text, record">
          {{ record.status === 0 ? '待审核' : (record.status === 1 ? '已通过' : '已驳回') }}
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { delWithdrawal, pageWithdrawal } from '@/api/master/withdrawal'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Withdrawal',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        userId: null,
        withdrawalMoney: null,
        commission: null,
        amountReceived: null,
        status: undefined,
        reason: null,
        withdrawalTime: null,
        examineTime: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '师傅名称',
          dataIndex: 'userName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '提现金额',
          dataIndex: 'withdrawalMoney',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '手续费',
          dataIndex: 'commission',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '到账金额',
          dataIndex: 'amountReceived',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '申请状态',
          dataIndex: 'status',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '审核原因',
          dataIndex: 'reason',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '提现时间',
          dataIndex: 'withdrawalTime',
          scopedSlots: { customRender: 'withdrawalTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '审核时间',
          dataIndex: 'examineTime',
          scopedSlots: { customRender: 'examineTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    if (!(this.$route.query && this.$route.query.id)) {
      this.getList()
    }
  },
  computed: {
  },
  watch: {
    '$route.query.id': {
      handler (id) {
        this.openDetailFromRoute(id)
      },
      immediate: true
    }
  },
  methods: {
    openDetailFromRoute (id) {
      if (id == null || id === '') {
        return
      }
      const status = this.$route.query.status
      if (status !== undefined && status !== null && status !== '') {
        this.queryParam.status = status
      }
      this.queryParam.pageNum = 1
      this.getList()
      this.$nextTick(() => {
        if (this.$refs.createForm) {
          this.$refs.createForm.handleUpdate({ id }, undefined)
        }
        this.clearRouteDetailIdQuery()
      })
    },
    clearRouteDetailIdQuery () {
      const q = { ...(this.$route.query || {}) }
      if (!q.id) {
        return
      }
      delete q.id
      this.$router.replace({ path: this.$route.path, query: q }).catch(() => {})
    },
    /** 查询师傅提现列表 */
    getList () {
      this.loading = true
      pageWithdrawal(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        userId: undefined,
        withdrawalMoney: undefined,
        commission: undefined,
        amountReceived: undefined,
        status: undefined,
        reason: undefined,
        withdrawalTime: undefined,
        examineTime: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          const data = []
          that.ids.map(id => data.push({ id: id }))
          return delWithdrawal(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('master/master-withdrawal/export', {
            ...that.queryParam
          }, `师傅提现_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
